// extracted by mini-css-extract-plugin
export default {"container":"MessageAttachment_container__pdwwo","mediaPreview":"MessageAttachment_mediaPreview__GXL7L"};